import React from 'react';

import scss from './ToolButton.module.scss';

function ToolButtonGroup({ children }) {
  return <div className={scss.group}>{children}</div>;
}

export default ToolButtonGroup;
